import { createAsyncThunk } from "@reduxjs/toolkit";
import certificateService from "../../../api/services/certificate";

export const getCertificateStatus = createAsyncThunk(
  "certificates/getCertificateStatus",
  async (courseId) => {
    return await certificateService.getCertificateStatus(courseId);
  }
);

export const applyCertificate = createAsyncThunk(
  "certificates/applyCertificate",
  async ({ courseId, data }) => {
    return await certificateService.applyCertificate(courseId, data);
  }
);

export const getUserApplications = createAsyncThunk(
  "certificates/getUserApplications",
  async () => {
    return await certificateService.getUserApplications();
  }
);

// Admin AsyncThunks
export const getAllApplications = createAsyncThunk(
  "certificates/getAllApplications",
  async (filters = {}) => {
    return await certificateService.getAllApplications(filters);
  }
);

export const approveApplication = createAsyncThunk(
  "certificates/approveApplication",
  async ({ applicationId, certificatePdf }) => {
    const response = await certificateService.approveApplication(applicationId, certificatePdf);
    return {
      applicationId,
      response
    };
  }
);
